import React from 'react';
import { motion } from 'motion/react';
import Reveal from './animations/Reveal';
import Stagger from './animations/Stagger';
import SectionDivider from './animations/SectionDivider';
import './HowJmiWorks.css';

const HowJmiWorks = () => {
  const steps = [
    {
      num: '01',
      title: 'Discover',
      tag: 'CATALOGUE INTEL',
      desc: 'Buyer discovers hallmarked products and verified jewellery manufacturers with clear purity and weight parameters.',
      points: ['Live metal rate sync', 'Purity filter (18K, 22K, 24K, 925)', 'Direct seller credentials'],
    },
    {
      num: '02',
      title: 'Order',
      tag: 'B2B ORDERING',
      desc: 'Buyer creates a structured wholesale order specifying exact gross weight, net weight, purity tolerance, and sizing.',
      points: ['Variant level breakdown', 'Bulk tiered making charge', 'Transparent bullion quote'],
    },
    {
      num: '03',
      title: 'Verify & Prepare',
      tag: 'ASSAY & OPERATOR AUDIT',
      desc: 'Seller accepts the order, locks inventory, and JMI operator oversees specification verification and hallmarking audit.',
      points: ['Inventory lock & allocation', 'Hallmarking verification', 'Vault staging'],
    },
    {
      num: '04',
      title: 'Fulfil',
      tag: 'SECURED LOGISTICS',
      desc: 'Vault-to-vault pickup, security checkpoint verification, and insured high-value transport workflows are coordinated.',
      points: ['Barcoded tamper bags', 'Armed escort / secure carrier', 'Real-time transit telemetry'],
    },
    {
      num: '05',
      title: 'Complete',
      tag: 'SETTLEMENT & RECORDS',
      desc: 'Buyer confirms physical receipt, weight audit verifies matching specs, and payment escrow settles to seller account.',
      points: ['Weighing slip reconciliation', 'Instant GST digital invoice', 'Permanent ledger history'],
    },
  ];

  return (
    <section className="how-jmi-works-section" id="how-it-works-steps">
      <div className="jmi-container">
        <Reveal variant="fadeUp" className="section-header-center">
          <div className="section-label">END-TO-END WORKFLOW</div>
          <h2 className="section-title">
            How <span className="gold-gradient-text">JMI Works</span>
          </h2>
          <p className="section-subtitle">
            A frictionless 5-stage procurement pipeline connecting buyer intent with seller supply,
            shielded by physical operator verification at every transaction milestone.
          </p>
        </Reveal>

        <SectionDivider style={{ marginBottom: 48 }} />

        <Stagger className="steps-flow-container" stagger={0.1} delayChildren={0.05}>
          {steps.map((step, idx) => (
            <Stagger.Item key={idx}>
              <motion.div
                className="workflow-step-card"
                whileHover={{ y: -4, transition: { duration: 0.22, ease: [0.22, 1, 0.36, 1] } }}
              >
                <div className="step-card-glow"></div>
                <div className="step-number-pill">{step.num}</div>
                <div className="step-tag">{step.tag}</div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.desc}</p>

                <div className="step-points-list">
                  {step.points.map((pt, pIdx) => (
                    <div key={pIdx} className="step-pt-item">
                      <span className="step-dot">✦</span>
                      <span>{pt}</span>
                    </div>
                  ))}
                </div>
              </motion.div>
            </Stagger.Item>
          ))}
        </Stagger>
      </div>
    </section>
  );
};

export default HowJmiWorks;
